import { InjectionToken } from '@angular/core';

export const SENTRY_ERROR_HANDLER_PARAMS_TOKEN = new InjectionToken<string>(
  'sentry-error-handler-params'
);
